import { emailFoot } from "src/components/email/EmailTemplate";
import {
  plainTextEmailHead,
  PlainTextEmailTemplate,
} from "src/components/email/PlainTextEmailTemplate";

export default function PlainEmailTest() {
  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: plainTextEmailHead }} />
      <PlainTextEmailTemplate
        content={`
      <p>Hey there!</p>

      <p>We have been using Captyn and love it, thought you all should chat!</p>
      
      <p>Best,<br />
      James</p>
      `}
      />
      <div dangerouslySetInnerHTML={{ __html: emailFoot }} />
    </>
  );
}
